import { useMsal } from "@azure/msal-react";
import { LocalStorageKeys } from "@repo/logic";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback, useState } from "react";

/** Keys to clear on logout to prevent data leaking between users */
const KEYS_TO_CLEAR: string[] = [
    LocalStorageKeys.REACT_QUERY_OFFLINE_CACHE,
    LocalStorageKeys.LAST_ACTIVITY,
    LocalStorageKeys.LAST_AML_CHECK,
    LocalStorageKeys.LAST_BANK_ID_CHECK,
    LocalStorageKeys.BANK_ID_LAST_ACTION,
    LocalStorageKeys.LAST_USED_AUTHORITY,
    LocalStorageKeys.AUTHORITY,
    LocalStorageKeys.DATA_CONFIG,
    "cp-query-cache", // persister key from main.tsx
];

export const useLogout = () => {
    const msal = useMsal();
    const queryClient = useQueryClient();
    const [isDisabled, setIsDisabled] = useState(false);

    const click: () => Promise<void> = useCallback(async () => {
        setIsDisabled(true);

        try {
            // Invalidate all queries and clear React Query cache
            queryClient.clear();

            // Remove all user-specific localStorage entries
            for (const key of KEYS_TO_CLEAR) {
                localStorage.removeItem(key);
            }

            await msal.instance.logoutRedirect();
        } catch (error) {
            setIsDisabled(false);
        }
    }, [msal.instance, queryClient]);

    return {
        isDisabled,
        click,
    };
};
